import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import logger from 'ws-scripts/modules/logger';
import { resetMakes } from '../features/make/makeSlice';

const LOG_PREFIX = '[ws-locations-facets][useResetMakeFilter]';

/**
 * Subscribes to the LocationsData reset-make-filter notification published
 * by ws-locations-data when ws-locations-control calls
 * LocationsData.resetMakeFilter(). Dispatches resetMakes() to keep Redux
 * selectedMakes in sync with the already-cleared LocationsData.filters.
 */
export const useResetMakeFilter = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		const locationsData = window.DDC?.LocationsData;

		if (!locationsData?.registerResetMakeFilterNotification) {
			logger.warn(
				`${LOG_PREFIX} LocationsData.registerResetMakeFilterNotification not available`
			);
			return () => {};
		}

		const handleReset = () => {
			logger.debug(
				`${LOG_PREFIX} Received reset-make-filter notification`
			);
			dispatch(resetMakes());
		};

		const unsubscribe =
			locationsData.registerResetMakeFilterNotification(handleReset);

		logger.debug(`${LOG_PREFIX} Subscribed to reset-make-filter`);

		return () => {
			if (unsubscribe) {
				unsubscribe();
			}
			logger.debug(`${LOG_PREFIX} Unsubscribed from reset-make-filter`);
		};
	}, [dispatch]);
};
